import type { ReactElement, ReactNode } from "react";
import { cn } from "../../lib/utils.js";

/** Shared pill for the containment status / priority / effectiveness tones. */
export function ContainmentChip({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}): ReactElement {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 rounded-full border px-1.5 py-0.5 text-dense-2 font-semibold",
        className,
      )}
    >
      {children}
    </span>
  );
}
